const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();

// ------------------------------------------------------------------------
// preLoad
// ----- BOTH
// ------------------------------------------------------------------------
const preLoad = () => {
  $(window).on('load' , function() {
    $("body").removeClass("preload");
    setTimeout(function() {
      if (document.getElementsByTagName("html")[0].classList.contains('wf-active') != true) {
          document.getElementsByTagName("html")[0].classList.add('loading-delay');
      }
    }, 3000);
  });
};

// ------------------------------------------------------------------------
// getCookie
// ----- BOTH
// ------------------------------------------------------------------------
const getCookie = () => {
  var arr = new Array();
  if (document.cookie != '') {
    var tmp = document.cookie.split('; ');
    for (var i = 0; i < tmp.length; i++) {
      var data = tmp[i].split('=');
      arr[data[0]] = decodeURIComponent(data[1]);
    }
  }
  return arr;
};

// ------------------------------------------------------------------------
// getCookie
// ----- BOTH
// ------------------------------------------------------------------------
function videoControl(action){
  var $playerWindow = $('#youtube-popup')[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
}


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};

// ------------------------------------------------------------------------
// mainvisualSlider
// ----- BOTH
// ------------------------------------------------------------------------
const mainvisualSlider = () => {
  $('.slider-mainvisual').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 3000,
  });
};

// ------------------------------------------------------------------------
// informationSlider
// ----- BOTH
// ------------------------------------------------------------------------
const informationSlider = () => {
  $('.slider-information').on('init', function(event, slick){
    infoScroll();
  });
  $(window).on('load', function() {
    $('.slider-information').slick({
      arrows: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 6000,
    });
  });
  // $('.slider-information').on('afterChange', function(event, slick, currentSlide){
  // });
};

// ------------------------------------------------------------------------
// pickupSlider
// ----- BOTH
// ------------------------------------------------------------------------
const pickupSlider = () => {
  $('.slider-pickup').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false,
    speed: 500,
    cssEase: 'ease',
    variableWidth: true,
    swipe: false,
    responsive: [
   {
     breakpoint: 1024,
     settings: {
       slidesToShow: 1,
       swipe: true,
       edgeFriction: 0.01
     }
   }
 ]
  });
};

// ------------------------------------------------------------------------
// movieSliderThumb
// ----- BOTH
// ------------------------------------------------------------------------
const movieSliderThumb = () => {
  $('.slider-movie-thumb').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false,
    speed: 500,
    cssEase: 'ease',
    variableWidth: true,
    rtl: true,
    asNavFor: '.slider-movie-detail',
    swipe: false,
    responsive: [
   {
     breakpoint: 1024,
     settings: {
       swipe: true,
       edgeFriction: 0.01
     }
   }
 ]
  });
};

// ------------------------------------------------------------------------
// movieSliderDetail
// ----- BOTH
// ------------------------------------------------------------------------
const movieSliderDetail = () => {
  $('.slider-movie-detail').slick({
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    fade: true,
    cssEase: 'ease',
    asNavFor: '.slider-movie-thumb',
  });
};

// ------------------------------------------------------------------------
// jacketSlider
// ----- BOTH
// ------------------------------------------------------------------------
const jacketSlider = () => {
  if( $('.slider-jacket').length ) {
    $('.slider-jacket').slick({
      arrows: false,
      dots: true,
      infinite: false,
      speed: 500,
      fade: true,
      cssEase: 'ease',
      customPaging: function(slick,index) {
          var targetImage = slick.$slides.eq(index).find('.img').attr('data-src');
          return '<button style="background:url(' + targetImage + ') no-repeat center center/contain"/>';
      }
    });
  }
};

// ------------------------------------------------------------------------
// bandSlider
// ----- BOTH
// ------------------------------------------------------------------------
const bandSlider = () => {
  $('.slider-band').slick({
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: 'ease',
    variableWidth: true,
  });
};

// ------------------------------------------------------------------------
// scrollSocial
// ----- BOTH
// ------------------------------------------------------------------------
const scrollSocial = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 600) {
      $(".st-Social").addClass("visible");
    } else {
      $(".st-Social").removeClass("visible");
    }
  });
};

// ------------------------------------------------------------------------
// scrollPagetop
// ----- BOTH
// ------------------------------------------------------------------------
const scrollPagetop = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 450) {
      $(".st-Pagetop").addClass("visible");
    } else {
      $(".st-Pagetop").removeClass("visible");
    }
  });
};

// ------------------------------------------------------------------------
// scrollHeader
// ----- BOTH
// ------------------------------------------------------------------------
const scrollHeader = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 60) {
      $(".st-Header").addClass("scrolled");
    } else {
      $(".st-Header").removeClass("scrolled");
    }
  });
};

// ------------------------------------------------------------------------
// scrollTodiagram
// ----- BOTH
// ------------------------------------------------------------------------
const scrollTodiagram = () => {
  if($('#diagram').length){
    $(window).on("load scroll", function() {
      let diagramPos = $("#diagram").offset().top - 100;
      let scrollHeight = $(this).scrollTop();
      if (scrollHeight > 100) {
        $(".chr-Contents_ToDiagram").addClass("scrolled");
        if (scrollHeight > diagramPos) {
          $(".chr-Contents_ToDiagram").removeClass("scrolled");
        }
      } else {
        $(".chr-Contents_ToDiagram").removeClass("scrolled");
      }
    });
  }
};

// ------------------------------------------------------------------------
// toggleAccordion
// ----- BOTH
// ------------------------------------------------------------------------
const toggleAccordion = () => {
  $(".accordion-button").on("click", function() {
    $(this).parent().next().slideToggle();
  });
};

// ------------------------------------------------------------------------
// indexModal
// ----- BOTH
// ------------------------------------------------------------------------
const indexModal = () => {
  var arr = getCookie();
  if (arr['flg'] != 1) {
    $(window).on('load',function() {
      $(".sw-Modal").toggleClass("open");
      document.cookie = "flg=1; path=/";
    });
  } else {
  }
  $('.idx-Mainvisual_Buttons .video a').on('click', function() {
    console.log("a");
    $(".sw-Modal").toggleClass("open");
    videoControl("playVideo");
  });
  $('.sw-Modal .button-close').on('click', function() {
    $(".sw-Modal").toggleClass("open");
    videoControl("pauseVideo");
  });
};

// ------------------------------------------------------------------------
// musicModal
// ----- BOTH
// ------------------------------------------------------------------------
const musicModal = () => {
  $('.listen a').on('click', function() {
    $(".sw-Modal").toggleClass("open");
    videoControl("playVideo");
  });
  $('.sw-Modal .button-close').on('click', function() {
    $(".sw-Modal").toggleClass("open");
    videoControl("pauseVideo");
  });
};

// ------------------------------------------------------------------------
// diagramModal
// ----- BOTH
// ------------------------------------------------------------------------
const diagramModal = () => {
  $('.button-zoom').on('click', function() {
    $(".sw-Modal").toggleClass("open");
  });
  $('.sw-Modal .button-close').on('click', function() {
    $(".sw-Modal").toggleClass("open");
  });
};

// ------------------------------------------------------------------------
// toggleMenu
// ----- BOTH
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.st-Header_Button > button').on('click', function() {
    $(this).toggleClass("open");
    $(".st-Header_Menu").toggleClass("open");
    $(".st-Header_Inner").toggleClass("open");
    $(".st-Social").toggleClass("open");
  });
};

// ------------------------------------------------------------------------
// changeChara
// ----- BOTH
// ------------------------------------------------------------------------
const changeChara = () => {
  $('.chr-Contents_Profile_Inner .change-normal').on('click', function() {
    $(this).toggleClass("changed");
    $(this).next().toggleClass("changed");
    $(this).next().next().toggleClass("changed");
    $(this).next().next().next().toggleClass("changed");
  });
  $('.chr-Contents_Profile_Inner .change-other').on('click', function() {
    $(this).prev().toggleClass("changed");
    $(this).toggleClass("changed");
    $(this).next().toggleClass("changed");
    $(this).next().next().toggleClass("changed");
  });
};

// ------------------------------------------------------------------------
// scrollAnimate
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnimate = () => {
  $(window).on('scroll load', function() {
    $('.js-anim').each(function() {
      let targetPos = $(this).offset().top;
      let scrollPos = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scrollPos > targetPos - windowHeight + windowHeight / 8) {
        $(this).addClass("animated")
      }
    });
  });
};

// ------------------------------------------------------------------------
// loadedAnimate
// ----- BOTH
// ------------------------------------------------------------------------
const loadedAnimate = () => {
  $(window).on('load', function() {
    $('.js-anim_load').each(function() {
      $(this).addClass("animated")
    });
  });
};

// ------------------------------------------------------------------------
// scrollKira
// ----- BOTH
// ------------------------------------------------------------------------
const scrollKira = () => {
  $(window).on('scroll', function(){
    var scrollTop = $(window).scrollTop();
    var bgPosition = scrollTop / 10;
    if(bgPosition){
      $("#style").html('body:before{background-position: center top -'+ bgPosition + 'px; }');
    }
  });
};

// ------------------------------------------------------------------------
// infoScroll
// ----- BOTH
// ------------------------------------------------------------------------
const infoScroll = () => {
  var windowsize = window.innerWidth;
  if (windowsize > 768) {
    $('.idx-Mainvisual_Inner .slider-information li a .text p').each(function() {
      const parentwidth = $(this).parent().innerWidth();
      const textwidth = $(this).innerWidth();
      if(textwidth > parentwidth) {
        const slidewidth = textwidth - parentwidth;
        let size = $('.idx-Mainvisual_Inner .slider-information li').length;
        console.log(size);
        let flag = 0;
        const self = $(this);
        if(size == 1) {
          setInterval(function(){
            if(flag == 0) {
              $(self).css('left',-slidewidth);
              $(self).css('transition','left 1s linear 1s');
              flag = 1;
            } else {
              // $(self).css('left','0');
              $(self).css('cssText','left: 0; transition: left 0.3s ease-out 1s !important;');
              flag = 0;
            }
          },3000);
        } else {
          $(self).css('left',-slidewidth);
          $(self).css('transition','left 1s linear 1s');
        }
      }
    });
  }
};

// ------------------------------------------------------------------------
// bandSelectAccordion
// ----- BOTH
// ------------------------------------------------------------------------
const bandSelectAccordion = () => {
  $('.msc-Select_Band button').on('click', function() {
    let button = $(this);
    let list = $(this).next('ul');

    button.toggleClass('open');
    list.slideToggle(300);
  });
}

// ------------------------------------------------------------------------
// setTableOfContents
// ----- BOTH
// ------------------------------------------------------------------------
function setTableOfContents() {
  let idcount = 0;
  let toc_html = '';
  let ht_arr = [];
  let a_arr = [];


  $('.sw-Contents :header', this).each(function() {
    if(this.nodeName.toLowerCase() == "h2") {
      ht_arr.push(2);
      idcount++;

    } else if(this.nodeName.toLowerCase() == "h3") {
      ht_arr.push(3);
      idcount++;
    }

    this.id = "i_" + idcount;

    let a = '<a href="#' + this.id + '">' + $(this).text() + '</a>';
    a_arr.push(a);
  });

  if( idcount >= 2 ) {
    toc_html += '<ul class="toc_list">';
    for(let i = 0; i + 1 < ht_arr.length; ++i) {
      if( ht_arr[i] == ht_arr[i + 1] ) {
        toc_html += '<li>' + a_arr[i] + '</li>';
      }
      else if( ht_arr[i] < ht_arr[i + 1] ) {
        toc_html += '<li>' + a_arr[i] + '<ul>';
      }
      else if( ht_arr[i] > ht_arr[i + 1] ) {
        toc_html += '<li>' + a_arr[i] + '</li>';

        let ulli_num = ht_arr[i] - ht_arr[i + 1];
        for(let j = 0; j < ulli_num; ++j) {
          toc_html += '</ul></li>';
        }
      }
    }

    toc_html += '<li>' + a_arr[ht_arr.length - 1] + '</li>';
    let ulli_num = ht_arr[ht_arr.length - 1] - 2;
    for(let j = 0; j < ulli_num; ++j) {
      toc_html += '</ul></li>';
    }
    toc_html += '</ul>';

    toc_html = '<p class="toc_title">Contents</p>' + toc_html;
    $("#toc_container").html(toc_html).css('display', '');
  }


  $('#toc_container').on('click', 'a[href^="#"]', function() {
    var linkSpeed    = 400;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 120;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
}


// ------------------------------------------------------------------------
// Article Setting
// ------------------------------------------------------------------------
const articleSetting = () => {
  $('.sw-Postbody p a').each(function() {
    if( $(this).find('img').length ) {
      $(this).addClass('img-link');
    }
  });

  $('.sw-Postbody .gallery a').each(function() {
    if( $(this).find('img').length ) {
      $(this).addClass('img-link');
    }
  });

  $('.sw-Postbody .gallery').each(function() {
    $(this).wrap('<div class="gallery-wrapper"></div>');
  });
}


// ------------------------------------------------------------------------
// orderChange
// ----- BOTH
// ------------------------------------------------------------------------
// const orderChange = () => {
//   $(window).on('scroll', function(){
//     target = document.getElementById("order-select");
//     selindex = document.form1.Select1.selectedIndex;
//     switch (selindex) {
//       case 1:
//         console.log("要素1が選択されています。");
//         break;
//       case 2:
//         console.log("要素2が選択されています。");
//         break;
//       case 3:
//         console.log("要素3が選択されています。");
//         break;
//       case 3:
//         console.log("要素4が選択されています。");
//         break;
//     }
//   });
// };

export {
  preLoad,
  anchorLink,
  scrollSocial,
  scrollPagetop,
  scrollHeader,
  mainvisualSlider,
  informationSlider,
  pickupSlider,
  movieSliderThumb,
  movieSliderDetail,
  jacketSlider,
  toggleAccordion,
  indexModal,
  bandSlider,
  scrollTodiagram,
  musicModal,
  diagramModal,
  toggleMenu,
  changeChara,
  scrollAnimate,
  loadedAnimate,
  scrollKira,
  infoScroll,
  bandSelectAccordion,
  setTableOfContents,
  articleSetting,
  // orderChange
}



// WEBPACK FOOTER //
// ./src/argo-bdp_v2/assets/js/include/module.js